/* SAEGE - Shop the look tab on product-page gallery images. 29/09/26.
   Markup: snippets/saege-pdp-looks.liquid (a <template> in the head).
   Sheet behaviour: assets/saege-shop-the-look.js (unchanged, shared with the
   collection pages).

   1. Clone the sheets out of the template into <body>.
   2. For each sheet, find the gallery slide(s) showing its image and put a
      "Shop the look" tab in the slide's bottom-right corner. The tab lives
      INSIDE the slide, so on mobile it travels with the image as you swipe
      and is only ever visible on that image - no slide-change listener
      needed. Slick's infinite-loop clones get a tab too.
   3. Tapping the tab opens the sheet.

   Why the tab does not carry data-saege-stl-open itself: the slide sits
   inside the theme's zoom/lightbox link, so a click that bubbles through the
   slide would also open the zoom. The tab's click is stopped in the capture
   phase at document (before the slide sees it) and a stand-in trigger in
   <body> is clicked instead, which reaches saege-shop-the-look.js's
   document listener without passing through the gallery. */
(function () {
  if (window.SaegePdpLooks) return;
  window.SaegePdpLooks = true;

  var ICON = '';

  function slideMatches(slide, m) {
    var id = m.getAttribute('data-saege-look-media');
    var mid = slide.getAttribute('data-media-id') || '';
    if (id && (mid === id || mid.slice(-(id.length + 1)) === '-' + id)) return true;
    var src = (m.getAttribute('data-saege-look-src') || '').replace(/\.[a-z0-9]+$/i, '');
    if (!src) return false;
    var img = slide.querySelector('img');
    if (!img) return false;
    var s = [img.currentSrc, img.src, img.getAttribute('data-src'), img.getAttribute('srcset'), img.getAttribute('data-srcset')].join(' ');
    return s.indexOf('/' + src) > -1;
  }

  function attach() {
    var modals = document.querySelectorAll('.saege-stl-modal--pdp');
    if (!modals.length) return;
    var slides = document.querySelectorAll('.gallery .main-image .slide[data-media-id]');
    modals.forEach(function (m) {
      slides.forEach(function (slide) {
        if (slide.querySelector('.saege-look-tab[data-look="' + m.id + '"]')) return;
        if (!slideMatches(slide, m)) return;
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'saege-stl__btn saege-stl__pos-bottom-right saege-look-tab';
        b.setAttribute('data-look', m.id);
        b.setAttribute('aria-haspopup', 'dialog');
        b.setAttribute('aria-controls', m.id);
        b.innerHTML = ICON + '<span>Shop the look</span>';
        slide.classList.add('saege-look-slide');
        slide.appendChild(b);
      });
    });
  }

  function init() {
    var tpl = document.getElementById('saege-pdp-looks');
    if (!tpl || tpl.getAttribute('data-done')) { attach(); return; }
    tpl.setAttribute('data-done', '1');
    var frag = tpl.content.cloneNode(true);
    var icon = frag.querySelector('.saege-look-tab__icon');
    if (icon) { ICON = icon.innerHTML; icon.remove(); }
    document.body.appendChild(frag);
    attach();
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('.saege-look-tab');
    if (!t) return;
    e.preventDefault();
    e.stopPropagation();
    var p = document.createElement('span');
    p.hidden = true;
    p.setAttribute('data-saege-stl-open', t.getAttribute('data-look'));
    document.body.appendChild(p);
    p.click();
    p.remove();
  }, true);

  // Slick can wrap or clone slides after we run; re-check when it settles.
  function rescan() { setTimeout(attach, 0); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  window.addEventListener('load', rescan);
  if (window.jQuery) {
    jQuery(document).on('init reInit', '.product-slideshow', rescan);
  }
  document.addEventListener('shopify:section:load', rescan);
})();
